import { PermissionsFormPage } from "~/pages/PermissionsFormPage";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/permissions/create")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([
    { title: "Permissions", link: `/${datasetSlug}/settings/permissions` },
    { title: "Create", link: `/${datasetSlug}/settings/permissions/create` },
  ]);
  return <PermissionsFormPage datasetSlug={datasetSlug} />;
}
